import type { ButtonHTMLAttributes, ElementType } from 'react';
import { cn } from '@/utils/cn';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  icon?: ElementType;
};

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-divergent-yellow text-black hover:bg-yellow-300',
  secondary: 'bg-white text-black hover:bg-white/90',
  ghost: 'bg-white/5 text-white hover:bg-white/10',
  danger: 'bg-red-500 text-white hover:bg-red-400'
};

export function Button({ className, children, variant = 'primary', icon: Icon, ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        'inline-flex min-h-10 items-center justify-center gap-2 rounded px-4 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50',
        variants[variant],
        className
      )}
      {...props}
    >
      {Icon ? <Icon size={18} aria-hidden="true" /> : null}
      {children}
    </button>
  );
}
